import { render, staticRenderFns } from "./webPrice.vue?vue&type=template&id=0d84f715"
import script from "./webPrice.vue?vue&type=script&lang=js"
export * from "./webPrice.vue?vue&type=script&lang=js"
import style0 from "./webPrice.vue?vue&type=style&index=0&id=0d84f715&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports